import { defineStore } from "pinia";
//import { reactive, ref } from "vue";

export const useBudgetDataStore = defineStore("BudgetDataStore", {
    id: "budgetDataStore",
    state: () => ({
      aggregatedBudgetChartData: [], // stores the rolled up budget grid data for reusability purposes
      isBudgetDataLoaded: false,
      currentProjectIds: '',
      currentEscalationQuery: '',
      fetchTimestamp: 0 // Used to force reactivity even when IDs are the same
    }),
    getters: {
      getAggregatedBudgetChartData: (state) => {
        return state.aggregatedBudgetChartData
      },
      getIsBudgetDataLoaded: (state) => {
        return state.isBudgetDataLoaded
      },
      getCurrentProjectIds: (state) => {
        return state.currentProjectIds
      },
      getCurrentEscalationQuery: (state) => {
        return state.currentEscalationQuery
      },
      getFetchTimestamp: (state) => {
        return state.fetchTimestamp
      }
    },
    actions: {
        setAggregatedBudgetChartData(aggregatedBudgetChartData) {
          this.aggregatedBudgetChartData = aggregatedBudgetChartData
        },
        setIsBudgetDataLoaded(isBudgetDataLoaded) {
            this.isBudgetDataLoaded = isBudgetDataLoaded
        },
        // Add the fetchBudgetData function
        fetchBudgetData(projectIds, escalationQuery) {
          console.log('🔥🔥🔥 budgetDataStore.fetchBudgetData V3 called with:', projectIds, escalationQuery);
          console.log('🔥🔥🔥 this before assignment:', this);
          
          // Reset loaded flag FIRST - BudgetGrid will set it to true when data is actually loaded
          this.isBudgetDataLoaded = false;
          
          // Store the current project IDs and escalation query  
          this.currentProjectIds = projectIds;
          this.currentEscalationQuery = escalationQuery;
          
          // Update timestamp to force reactivity - use $patch for guaranteed reactivity
          const timestamp = Date.now();
          console.log('🔥🔥🔥 Setting timestamp to:', timestamp);
          
          this.$patch({
            fetchTimestamp: timestamp
          });
          
          console.log('🔥🔥🔥 After $patch, this.fetchTimestamp:', this.fetchTimestamp);
        }
    }
})